import React from 'react'
import './loginForm.css'
import logoSB from '../../../../../../assets/img/logo-colores-originales-sin-bajada.png'
import { useSubmitControler } from '../../loginController'
import { useState, useEffect, useContext } from 'react'
import ReactBootstrapModal from '../../../../../feedback/modal/Modal'
import { useRedirect } from '../../../../../../hooks/useRedirect'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useToast } from '../../../../../../hooks/useToast'
import { AuthContext } from '../../../../../../context/Authcontext'
import { useForgotPassword } from '../../loginController'

export const UserLoginForm = () => {

    useEffect(() => {
        document.title = 'TPA® Oficial - Iniciar sesión'
    }, [])


    const { handleSubmit, register, onSubmit, message, response, errors ,setMessage,setResponse} = useSubmitControler()
    const { submitHandler, reg, onResetPassword, fpmessage, fpresponse, validationErrors,setfpResponse,setfpMessage } = useForgotPassword()

    const [showPassword, setShowPassword] = useState(true)
    const [showModalRecovery, setshowModalRecovery] = useState(false);
    const [showModalUnlockUser, setshowModalUnlockUser] = useState(false);

    const { showToast } = useToast();
    const { login } = useContext(AuthContext)
    const { redirectTo } = useRedirect()

  
  
    useEffect(() => {

        if (response) {
            //console.log('response ES: ', response)
            if (response.status === 200 && response.data.accessToken) {


                login()
                redirectTo('/biblioteca', response.status)

            }

        }

    }, [redirectTo, response, login])



    //! Redireccion con respuesta del modal

    useEffect(() => {

        if (fpresponse) {
            //console.log('fpresponse ES: ', fpresponse)

            redirectTo('/completed-form', fpresponse.status, {
                message: `${fpmessage}`,
                title: "¡Éxito!"
            });

        }



    }, [redirectTo, fpresponse])


    //? toast en respuesta del modal de desbloqueo o recuperar contraseña

    useEffect(() => {
        if (fpmessage && fpresponse) {
            // console.log('fpmessage && fpresponse: ', fpresponse, fpmessage)
            showToast(fpresponse, fpmessage)
            setfpResponse(null)
            setfpMessage('')
            // setToastShown(true)
        }
    }, [fpmessage, showToast, fpresponse])


    //?👉 Función para cambiar el estado del modal
    const toggleModal = () => {
        setshowModalRecovery(!showModalRecovery);
    }


    const toggleUnlockUser = () => {
        setshowModalUnlockUser(!showModalUnlockUser);
    }


    //?👉 Función mostrar la contraseña
    const togleEye = () => {
        setShowPassword(!showPassword)
    }


    //Funcion para mostrar toast


    // const [toastShown, setToastShown] = useState(false)
    // const toastId = React.useRef(null);

    // const memoizedShowToast = useCallback((response, message) => { 
    //        // tu lógica de showToast aquí

    //        }, [showToast])
    


//eslint-disable-next-line react-hooks/exhaustive-deps

//? Toast para la respuesta del login

    useEffect(() => {
        if (message && response) {
            // console.log('RESULT ES: ', response, message)
            showToast(response, message)
            setMessage('')
            setResponse(null)

        }
    }, [message, response])

    

// console.log('SE RE RENDERIZA')

    return (
        <div className="form-container">

            <ToastContainer
            />

            <form className="form-login" onSubmit={handleSubmit(onSubmit)}>

                <div className="logo-login">
                    <img src={logoSB} alt="logo" />
                </div>

                <h1 className="title title-login ">Bienvenido</h1>

                <div className="form-floating mb-3">
                    <input
                        {...register('username', { required: 'email is required' })}
                        type="text"
                        name={'username'}
                        className={`form-control ${errors.username ? 'inError' : ''}`}
                        id="floatingInput"
                        autoFocus autoComplete='userName'
                        placeholder="Usuario"
                    />
                    <label htmlFor="floatingInput">Usuario</label>
                </div>




                <div className="input-group">


                    <div className="form-floating flex-grow-1">

                        <input
                            {...register('password', { required: 'password is required', })}
                            type={showPassword ? "password" : "text"}
                            className={`form-control ${errors.password ? 'inError' : ''}`}
                            name={'password'}
                            id="floatingPassword"
                            placeholder="Contraseña"
                            autoComplete="current-password"
                        />
                        <label htmlFor="floatingPassword">Contraseña</label>

                        <span className="span-eye toggle-password" ><i onClick={() => togleEye()} className={showPassword ? "bi bi-eye-slash bi-class-eye" : "bi bi-eye bi-class-eye"}></i></span>

                    </div>


                </div>
                <a href="/" className="link linkPassword text-end" onClick={(e) => { e.preventDefault(); toggleModal(); }}>
                    ¿Olvidaste tu contraseña?
                </a>




                {/* <div id="errorMessage" className="error-message">{message}</div> */}

                <input type="submit" className="button" value="Acceder" />
                <p className='mt-2 yanm'>¿No sos miembro?
                    <Link to="/formulario-interes" className='link ps-2' >Registrate</Link>
                </p>

                <a href="/home" className="link linkUnlockUser" onClick={(e) => { e.preventDefault(); toggleUnlockUser(); }}>¿Bloqueaste tu usuario?</a>

                {/* <Link to="#" className="link">Necesitas ayuda?</Link> */}
            </form>



            <ReactBootstrapModal
                submitHandler={submitHandler}
                reg={reg}
                onResetPassword={onResetPassword}
                validationErrors={validationErrors}
                showModalRecovery={showModalRecovery}
                toggleModal={toggleModal}
                text={'Recuperar contraseña'}
                textButton={'Recuperar'}
            />

            <ReactBootstrapModal
                submitHandler={submitHandler}
                reg={reg}
                onResetPassword={onResetPassword}
                validationErrors={validationErrors}
                showModalUnlockUser={showModalUnlockUser}
                toggleModal={toggleUnlockUser}
                text={'Desbloquear usuario'}
                textButton={'Desbloquear'} />

        </div>
    )
}

